(()=>{
  const init=(scope=document)=>scope.querySelectorAll('[data-cx-explorer]:not([data-cx-initialized])').forEach(root=>{
    root.dataset.cxInitialized='true';
    const views=[...root.querySelectorAll('[data-cx-view]')];
    const panels=[...root.querySelectorAll('[data-cx-panel]')];
    const stars=[...root.querySelectorAll('[data-cx-star]')];
    const notes=[...root.querySelectorAll('[data-cx-star-note]')];
    const status=root.querySelector('[data-cx-status]');
    const stage=root.querySelector('[data-cx-stage]');
    const showView=(key,announce=false)=>{
      views.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.cxView===key)));
      panels.forEach(p=>p.hidden=p.dataset.cxPanel!==key);
      stage.dataset.cxStage=key;
      if(announce&&status){const b=views.find(b=>b.dataset.cxView===key);status.textContent=b?.textContent.trim()||'';}
    };
    const showStar=(key,announce=false)=>{
      stars.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.cxStar===key)));
      notes.forEach(p=>p.hidden=p.dataset.cxStarNote!==key);
      if(announce&&status){const n=notes.find(n=>n.dataset.cxStarNote===key);status.textContent=n?.textContent.trim()||'';}
    };
    views.forEach(b=>b.addEventListener('click',()=>showView(b.dataset.cxView,true)));
    stars.forEach(b=>b.addEventListener('click',()=>showStar(b.dataset.cxStar,true)));
    [views,stars].forEach(group=>group.forEach((button,index)=>button.addEventListener('keydown',e=>{
      if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
      e.preventDefault();
      const next=e.key==='Home'?0:e.key==='End'?group.length-1:(index+(e.key==='ArrowRight'?1:-1)+group.length)%group.length;
      group[next].focus();group[next].click();
    })));
    showView('locate');if(stars.length)showStar(stars[0].dataset.cxStar);
    root.querySelectorAll('[data-cx-controls]').forEach(el=>el.hidden=false);
    root.classList.add('cx-ready');
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
